module.exports = __webpack_public_path__ + "img/michigan-gaming-control-board.a458a995.png";